import keyBy from 'lodash/keyBy'
import Vue from 'vue'
import Component from 'vue-class-component'

import { ActivityResult, Course, User, VueFire } from '@codee-club/common/dist/dao'

import HomeCourse from '../Home/HomeCourse/HomeCourse.vue'

@Component({ components: { HomeCourse } })
export default class OpenCourses extends Vue {
  get user(): VueFire<User> | null {
    return this.$store.state.currentUser
  }

  get openCourses(): Array<VueFire<Course>> {
    return this.$store.state.openCourses
  }

  get keyedResults(): { [activityId: string]: VueFire<ActivityResult> } {
    const myResults: Array<VueFire<ActivityResult>> = this.$store.state.myResults
    return keyBy(myResults, 'activityId')
  }

  isJoined(course: VueFire<Course>): boolean {
    const userId = this.user?.id
    if (userId === undefined) return false
    return course.roleEdit?.includes(userId) || course.roleView?.includes(userId) || false
  }

  getCourseLink(course: VueFire<Course>): any {
    if (!this.user) {
      return { name: 'Login' }
    }
    if (this.isJoined(course)) {
      return { name: 'Course', params: { courseSlug: course.slug } }
    }
    return { name: 'CourseJoin', params: { courseSlug: course.slug } }
  }
}
